module.exports = __webpack_public_path__ + "files/folliot.71884a1564679a67b385f349f5f62e4a.pdf";